<template>
        <div class="row">
                <div class="col-md-8 offset-2 breadcrumb-class mt-3">Está en: <span><a href="">Resumen</a></span></div>
        </div>
        <div class="row mt-4 mb-4">
                <div class="col-md-8 offset-md-2 mb-4">
                        <div class="float-right">
                        <modal-button content="Crear nuevo usuario" target="createUserModal" buttonClass="btn btn-dark mr-2">
                        </modal-button>
                        <button class="btn btn-dark" @click="generateXLSXReport">Generar reporte</button>
                        </div>
                        

                        <div class="user_table">
                                <table id="table" class="display table-bordered table-hover table" cellspacing="0" widht="100%">
                                        <thead>
                                                <tr>
                                                        <th>Nombre</th>
                                                        <th>Apellido</th>
                                                        <th>Dependencia</th>
                                                        <th>Email</th>
                                                        <th>Rol</th>
                                                        <th>Acciones</th>
                                                </tr>
                                        </thead>
                                        <tbody>
                                                <tr v-for="(user, index) in users" :key="index">
                                                        <td>{{ user.name }}</td>
                                                        <td>{{ user.lastname }}</td>
                                                        <td>{{ user.institution }}</td>
                                                        <td>{{ user.email}}</td>
                                                        <td>{{ user_translate(user.role_code)}}</td>
                                                        <td>
                                                                <button type="button" class="btn btn-sm btn-dark mr-2" data-toggle="modal" data-target="#deleteUserModal" v-on:click="change_selected_user(user.id,user.name+' '+user.lastname,user.active)">
                                                                        Eliminar
                                                                </button>
                                                                <button type="button" class="btn btn-sm btn-dark" data-toggle="modal" data-target="#updateUserModal" v-on:click="change_selected_user(user.id,user.name+' '+user.lastname,user.active)">
                                                                       Cambiar Contra 
                                                                </button>
                                                                <button type="button" class="btn btn-sm btn-dark" data-toggle="modal" data-target="#changeUserStateModal" v-on:click="change_selected_user(user.id,user.name+' '+user.lastname,user.active)">
                                                                       {{ (user.active == true)?'Desactivar':'Activar'}} usuario 
                                                                </button>
                                                        </td>
                                                </tr>
                                        </tbody>
                                </table>
                        </div>
                </div>
        </div>
        <!-- Modals  -->
        <create-user></create-user>
        <delete-user-modal-component :user_id="selected_user_id" :user_name="selected_user_name" @deleted="refreshUsers"></delete-user-modal-component>
        <update-user-modal-component :user_id="selected_user_id"></update-user-modal-component>
        <change-user-state-modal :user_id="selected_user_id" :user_name="selected_user_name" :user_status="selected_user_status" @statusChanged="refreshUsers"></change-user-state-modal>
</template>

<script>
import axios from "axios"
import api_routes from "../../assets/js/api_routes.js"
import createUser from '../../components/forms/createUserModalComponent.vue'
import modalButton from '../../components/modalButtonComponent.vue'
import deleteUser from '../../components/forms/deleteUserModalComponent.vue'
import updateUser from '../../components/forms/updateUserModalComponent.vue'
import changeUserStateModal from '../../components/forms/ChangeUserStateModalComponent.vue'
import XLSX from 'xlsx'

export default {
        name: "userPanel",
        components:{'create-user': createUser, 'modal-button': modalButton
        , 'delete-user-modal-component': deleteUser, 'update-user-modal-component': updateUser,
        'change-user-state-modal': changeUserStateModal},                      
        data() {
                return {
                        headerFields: [
                        {
                        name: "",
                        label: "",
                        sortable: true,
                        dataTable: null,
                        },
                        ],
                        users: [],
                        selected_user_id: 0,
                        selected_user_name: '',
                        selected_user_status:''
                }
        },
        methods: {
                getUsers() {
                        //TODO this function need be move to VUEX store
                        axios
                        .post(api_routes.get_users)
                        .then((resp) => {
                                resp.data.data.forEach((user) => {
                                this.users.push(user);
                                })
                                console.log(this.users)
                        })
                        .catch((err) => {
                                alert("Error de conexión");
                                console.log(err)
                        });
                },
                user_translate(code){
                        let translate = ""
                        if(code == 3){
                               translate = "Administrador" 
                        }else if(code == 4){
                                translate = "Consultor"
                        }
                        
                        return translate
                },
                change_selected_user(user_id, user_name, status){
                       this.selected_user_id = user_id 
                       this.selected_user_name = user_name
                       this.selected_user_status =  status
                },
                refreshUsers(){
                        this.users = []
                        this.getUsers()
                },
                generateXLSXReport(){
                        let data_array = this.translate_users_data()
                        let workbook = XLSX.utils.book_new()
                        let worksheet = XLSX.utils.json_to_sheet(data_array,{raw: true})
                        XLSX.utils.book_append_sheet(workbook, worksheet,"Usuarios")
                        workbook["Sheets"]["Usuarios"]["!cols"] = new Array(10).fill({wpx:100})
                        try{
                                XLSX.writeFile(workbook, `reporte_usuarios.xlsx`)
                        }catch(err){
                                console.log(err, workbook)
                        } 
                },
                translate_users_data(){
                        const temp = this.users
                        let result = []
                        temp.forEach(user => {
                               result.push({
                                       Nombre: user.name,
                                       Apellido: user.lastname,
                                       Institucion: user.institution,
                                       Email: user.email,
                                       Rol: (user.role_code == 3)?"Administrador":"Consultor",
                                       Estado: (user.active)?"Activo":"Inactivo"
                               }) 
                        });

                        return result
                }
        },
        beforemount() {

        },
        mounted() {
                this.$store.dispatch("sidebar_state", "close");
                this.getUsers();
        },
}
</script>

<style scoped>

.user_table{
        height:460px;
        overflow:scroll;
        margin-top: 10%;
}
</style>
